import { render } from "./ButtonNav.vue?vue&type=template&id=71ea906e&scoped=true"
import script from "./ButtonNav.vue?vue&type=script&lang=js"
export * from "./ButtonNav.vue?vue&type=script&lang=js"

import "./ButtonNav.vue?vue&type=style&index=0&id=71ea906e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ea906e"]])

export default __exports__